import React, { StrictMode, useEffect } from 'react';
import { Router } from 'react-router-dom';

import adapter from '@flopflip/memory-adapter';
import { ConfigureFlopFlip } from '@flopflip/react-redux';
import history from '@history';
import { StyledEngineProvider } from '@mui/material/styles';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import Provider from 'react-redux/es/components/Provider';

import { adapterArgs, localFeatureFlags } from 'constants/featureFlags';
import { registerSsoDeepLinkListener } from 'utils/native/ssoBrowser';

import store from 'store/global';

import AppContext from './AppContext';
import { Authentication } from './auth';
import routes from './configs/routesConfig';
import ErrorBoundary from './ErrorBoundary';
import { DefaultLayout } from './layouts';
import AppThemeProvider from './providers/theme';
import FeatureToggler from './shared/components/common/FeatureToggler';

import '@fake-db';

dayjs.extend(utc);

const AppContextValue = {
  routes,
};

const App = () => {
  useEffect(() => {
    const listenerPromise = registerSsoDeepLinkListener();

    return () => {
      listenerPromise.then(listener => listener?.remove());
    };
  }, []);

  return (
    <ErrorBoundary>
      <AppContext.Provider value={AppContextValue}>
        <StyledEngineProvider injectFirst>
          <Provider store={store}>
            <AppThemeProvider.CDS>
              <StrictMode>
                <ConfigureFlopFlip
                  adapter={adapter}
                  adapterArgs={adapterArgs}
                  defaultFlags={localFeatureFlags}
                >
                  <FeatureToggler>
                    <Authentication>
                      <Router history={history}>
                        <DefaultLayout />
                      </Router>
                    </Authentication>
                  </FeatureToggler>
                </ConfigureFlopFlip>
              </StrictMode>
            </AppThemeProvider.CDS>
          </Provider>
        </StyledEngineProvider>
      </AppContext.Provider>
    </ErrorBoundary>
  );
};

export default App;
